import type {LegalForm} from '../../constants/legalFormTypes'
import {PRIVATE_PERSON} from '../../constants/legalFormTypes'
import {bornNumberMatchesBirthday} from '../utils'

export const isBornNumberValid = (legalForm: LegalForm, birthday?: string, bornNumber?: string) =>
  Boolean(legalForm !== PRIVATE_PERSON || !birthday || !bornNumber || bornNumberMatchesBirthday(bornNumber, birthday))
